// @ts-nocheck
export const URL = process.env.PUBLIC_URL + '/assets/characters/SkeletorMinionForAnimation.gltf'

export const useModel = (): GLTFResult => {
  const { nodes, materials } = useGLTF(URL) as GLTFResult
  Object.values(nodes).forEach(n =>
    n.traverse(ch => {
      ch.type === 'Mesh' ? (ch.castShadow = true) : null
    }),
  )
  return { nodes, materials }
}
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & {
  nodes: {
    Cube7655: THREE.Mesh
    Cube7655_1: THREE.Mesh
    Cube7653: THREE.Mesh
    Cube7653_1: THREE.Mesh
    Cube7654: THREE.Mesh
    Cube7654_1: THREE.Mesh
    Cube7654_2: THREE.Mesh
    Cube7654_3: THREE.Mesh
    character_skeleton_minion_eyes: THREE.Mesh
    character_skeleton_minion_jaw: THREE.Mesh
    Cube7650: THREE.Mesh
    Cube7650_1: THREE.Mesh
    character_skeleton_minion_body: THREE.Group
    character_skeleton_minion_armRight: THREE.Group
    character_skeleton_minion_armLeft: THREE.Group
    character_skeleton_minion_head: THREE.Group
  }
  materials: {
    Stone: THREE.MeshStandardMaterial
    White: THREE.MeshStandardMaterial
    BrownDark: THREE.MeshStandardMaterial
    Black: THREE.MeshStandardMaterial
    Metal: THREE.MeshStandardMaterial
    Glow: THREE.MeshStandardMaterial
  }
}

export function Model(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF(URL) as GLTFResult
  return (
    <group {...props} dispose={null}>
      <group name="KayKit_AnimatedCharacter_v12glb" userData={{ name: 'KayKit_AnimatedCharacter_v1.2.glb' }}>
        <group name="KayKit_Animated_Character_1" userData={{ name: 'KayKit_Animated_Character_1' }}>
          <group name="Body" userData={{ name: 'Body' }}>
            <group
              name="armLeft"
              position={[0.14, 0.69, 0]}
              rotation={[Math.PI / 2, -1.08, -Math.PI / 2]}
              userData={{ name: 'armLeft' }}
            >
              <group
                name="character_skeleton_minion_armLeft"
                position={[0.01, 0.12, -0.03]}
                rotation={[-3.11, -1.28, -0.54]}
                userData={{ name: 'character_skeleton_minion_armLeft' }}
              >
                <mesh
                  castShadow
                  receiveShadow
                  name="Cube7655"
                  geometry={nodes.Cube7655.geometry}
                  material={materials.Stone}
                  userData={{ name: 'Cube7655' }}
                />
                <mesh
                  castShadow
                  receiveShadow
                  name="Cube7655_1"
                  geometry={nodes.Cube7655_1.geometry}
                  material={materials.White}
                  userData={{ name: 'Cube7655_1' }}
                />
              </group>
            </group>
            <group
              name="armRight"
              position={[-0.14, 0.69, 0]}
              rotation={[-Math.PI / 2, -1.08, Math.PI / 2]}
              userData={{ name: 'armRight' }}
            >
              <group
                name="character_skeleton_minion_armRight"
                position={[0.02, 0.09, 0.03]}
                rotation={[2.88, -1.29, 0.22]}
                userData={{ name: 'character_skeleton_minion_armRight' }}
              >
                <mesh
                  castShadow
                  receiveShadow
                  name="Cube7653"
                  geometry={nodes.Cube7653.geometry}
                  material={materials.Stone}
                  userData={{ name: 'Cube7653' }}
                />
                <mesh
                  castShadow
                  receiveShadow
                  name="Cube7653_1"
                  geometry={nodes.Cube7653_1.geometry}
                  material={materials.White}
                  userData={{ name: 'Cube7653_1' }}
                />
              </group>
            </group>
            <group name="character_skeleton_minion_body" userData={{ name: 'character_skeleton_minion_body' }}>
              <mesh
                castShadow
                receiveShadow
                name="Cube7654"
                geometry={nodes.Cube7654.geometry}
                material={materials.BrownDark}
                userData={{ name: 'Cube7654' }}
              />
              <mesh
                castShadow
                receiveShadow
                name="Cube7654_1"
                geometry={nodes.Cube7654_1.geometry}
                material={materials.White}
                userData={{ name: 'Cube7654_1' }}
              />
              <mesh
                castShadow
                receiveShadow
                name="Cube7654_2"
                geometry={nodes.Cube7654_2.geometry}
                material={materials.Black}
                userData={{ name: 'Cube7654_2' }}
              />
              <mesh
                castShadow
                receiveShadow
                name="Cube7654_3"
                geometry={nodes.Cube7654_3.geometry}
                material={materials.Metal}
                userData={{ name: 'Cube7654_3' }}
              />
            </group>
            <group name="Head" position={[0, 0.71, 0]} userData={{ name: 'Head' }}>
              <group
                name="character_skeleton_minion_head"
                position={[0, 0.06, 0.06]}
                userData={{ name: 'character_skeleton_minion_head' }}
              >
                <mesh
                  castShadow
                  receiveShadow
                  name="character_skeleton_minion_eyes"
                  geometry={nodes.character_skeleton_minion_eyes.geometry}
                  material={materials.Glow}
                  position={[0, 0.42, 0.26]}
                  userData={{ name: 'character_skeleton_minion_eyes' }}
                />
                <mesh
                  castShadow
                  receiveShadow
                  name="character_skeleton_minion_jaw"
                  geometry={nodes.character_skeleton_minion_jaw.geometry}
                  material={materials.White}
                  position={[0, 0.13, 0.04]}
                  userData={{ name: 'character_skeleton_minion_jaw' }}
                />
                <mesh
                  castShadow
                  receiveShadow
                  name="Cube7650"
                  geometry={nodes.Cube7650.geometry}
                  material={materials.White}
                  morphTargetDictionary={nodes.Cube7650.morphTargetDictionary}
                  morphTargetInfluences={nodes.Cube7650.morphTargetInfluences}
                  userData={{
                    targetNames: ['Angry', 'Happy'],
                    name: 'Cube7650',
                  }}
                />
                <mesh
                  castShadow
                  receiveShadow
                  name="Cube7650_1"
                  geometry={nodes.Cube7650_1.geometry}
                  material={materials.Black}
                  morphTargetDictionary={nodes.Cube7650_1.morphTargetDictionary}
                  morphTargetInfluences={nodes.Cube7650_1.morphTargetInfluences}
                  userData={{
                    targetNames: ['Angry', 'Happy'],
                    name: 'Cube7650_1',
                  }}
                />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload(URL)
